import { render, staticRenderFns } from "./ActorCall.vue?vue&type=template&id=dbddfe10&scoped=true"
import script from "./ActorCall.vue?vue&type=script&lang=js"
export * from "./ActorCall.vue?vue&type=script&lang=js"
import style0 from "./ActorCall.vue?vue&type=style&index=0&id=dbddfe10&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbddfe10",
  null
  
)

export default component.exports